//Styles
import './modal.scss';


export interface ModalProps {
    open?: boolean;
    component?:JSX.Element;
    closeModal: () => void;
}

const TransitionsModal = (props: ModalProps) => {
  return (
    <div className="modal">
        {props.open && (
          <div className="modal-wrapper">
            <div className="bg" onClick={props.closeModal}></div>
            <div className="content">{props.component}</div>
          </div>
        )}
    </div>
  );
}


export default TransitionsModal;